module.exports = __webpack_public_path__ + "static/img/eidDetails.4b22284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eidDetails.png
// module id = KLdQ
// module chunks = 44